import { AutoPlaySlider } from "../AutoPlaySlider";
import React, { useEffect } from 'react';
import { Box, Grid, Skeleton, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectComponentStore } from "../../../system/PageStore";
//
import { DefaultSetting, HomePageSectionOne, HomePageSectionTwo } from '../../defaultSetting';
import { TopBanner } from '../../components/TopBanner';
//
import { useGetGalleryDataQuery } from "../../../system/Features/getGalleryData";
import { closeHomePagePopUpImg, homePageSliderMove, switchSliderHover } from "../../../system/Slicer/HomePageSlicer";
import { ArrowControl } from "../../components/Slider/ArrowControl";
import { DottedControl } from "../../components/Slider/DottedControl";
//
import { NewsData } from '../../../data/NewsData';
import { NewsBox } from '../NewsBox';
//
import { HomePageMaterials } from "./HomePageMaterials";
import { HomePageButtonsGroup } from "./HomePageButtonsGroup";
import { HomePageUseFullLinkGroup } from "./HomePageUsefullLinkGroup";
//
import { EventGallery } from "../EventGallery";
import { useGetEventGalleryDataQuery } from "../../../system/Features/getEventGalleryData";
import { changePopUpStates } from "../../../system/Slicer/CommonSlicer";

export function HomePage() {
    useEffect(() => {
        console.log('🏠 HomePage mounted');
    }, []);
    const isPc = useMediaQuery('(min-width:600px)');
    const dispatch = useDispatch();
    const componentStates = useSelector(selectComponentStore);
    let sectionOneHeight = isPc ? HomePageSectionOne.height.pc : HomePageSectionOne.height.mb;


    const setSlider = (index: number, lastIndex?: number) => {
        if (galleryImgData.isSuccess) {
            let nextIndex = index;
            if (index == galleryImgData.data!.length) nextIndex = 0;
            if (index <= -1) nextIndex = galleryImgData.data!.length - 1;
            dispatch(homePageSliderMove(nextIndex))
        }
        return {}
    }

    //PoPupPage
     if (componentStates.HomePageComponentReducer.homePagePopUpImg) {
         dispatch(changePopUpStates({
             src: "https://www.pkps.edu.hk/img/popup_openday2627.jpg",
             onclickClose: true,
             imageOnClick: () => { window.open("https://forms.gle/4q7NjTuqVSJzV3Pm7", '_blank') },
         }));
         dispatch(closeHomePagePopUpImg(true));
     }

    let galleryImgData = useGetGalleryDataQuery("");
    let eventData = useGetEventGalleryDataQuery("");

    return (
        <>
            <TopBanner />
            <Box sx={{ px: { xs: 0, sm: 2 }, py: 2 }}>
                <Grid container direction="row" justifyContent="center" alignItems="top" spacing={{ xs: 0, sm: 2 }}>
                    <Grid item xs={12} sm={8} sx={{ width: { xs: "100vw", sm: "auto" }, maxWidth: { xs: "100vw", sm: "66.666667%" } }}>
                        {
                            galleryImgData.isSuccess && galleryImgData.data ?
                                <AutoPlaySlider
                                    onMouseLeave={() => { dispatch(switchSliderHover()) }}
                                    onMouseEnter={() => { dispatch(switchSliderHover()) }}
                                    height={sectionOneHeight}
                                    event={setSlider}
                                    data={galleryImgData.data!}
                                >
                                    {((componentStates.HomePageComponentReducer.isHoverSlider && isPc) || !isPc) &&
                                        <ArrowControl
                                            sx={{ backgroundColor: "black" }}
                                            leftClick={() => { setSlider(componentStates.HomePageComponentReducer.homePageSliderIndex - 1) }}
                                            rightClick={() => { setSlider(componentStates.HomePageComponentReducer.homePageSliderIndex + 1) }}
                                        />
                                    }
                                    {isPc &&
                                        <DottedControl
                                            boxSx={{ backgroundColor: DefaultSetting.transparentBG, position: "absolute", bottom: "3%" }}
                                            data={Array.from(galleryImgData.data!)}
                                            nowIndex={componentStates.HomePageComponentReducer.homePageSliderIndex}
                                            onclick={setSlider}
                                        />
                                    }

                                </AutoPlaySlider>
                                :
                                <Box component="div" sx={{ position: "relative", width: 1, overflow: "hidden", borderRadius: DefaultSetting.borderRadius }} >
                                    <Skeleton
                                        variant="rectangular"
                                        sx={{ backgroundColor: "#F0F0F0" }}
                                        animation="wave"
                                        height={HomePageSectionOne.height.pc}
                                    />
                                </Box>
                        }
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <NewsBox data={NewsData} sx={{ minHeight: HomePageSectionOne.height.pc }} />
                    </Grid>
                </Grid>
                <EventGallery loading={!eventData.isSuccess} data={eventData.isSuccess ? eventData.data : null} />
                <HomePageButtonsGroup />
                <HomePageMaterials />
                <HomePageUseFullLinkGroup />
            </Box>
        </>
    )
}
